import { render, staticRenderFns } from "./bao-cao-tong-hop.vue?vue&type=template&id=5f9ac18e&scoped=true&"
import script from "./bao-cao-tong-hop.vue?vue&type=script&lang=js&"
export * from "./bao-cao-tong-hop.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-tong-hop.vue?vue&type=style&index=0&id=5f9ac18e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9ac18e",
  null
  
)

export default component.exports